import React from 'react';

import { Box, Icon, Text } from '@betterment/samba-react';
import { Button, CenteredWorkflowLayout, Flex, Heading, SectionLayout } from '@betterment/style-closet-react';

import CheckingSplashImage from '../../../images/checking_splash.png';
import Footer from '../../../Shared/components/Footer';

interface Props {
  handleClick: () => void;
}
interface PerkProps {
  icon: React.JSX.Element;
  text: string;
}

const Perk: React.FC<React.PropsWithChildren<PerkProps>> = ({ icon, text }) => {
  return (
    <Box
      css={{
        marginBottom: 'space.compat-7',
      }}
    >
      <Flex flexDirection="row" alignItems="top">
        <Box
          css={{
            marginRight: 'space.compat-2',
          }}
        >
          {icon}
        </Box>
        <Text as="p" css={{ marginBottom: 'space.200', _last: { marginBottom: 'space.0' } }}>
          {text}
        </Text>
      </Flex>
    </Box>
  );
};

const Checking: React.FC<React.PropsWithChildren<Props>> = ({ handleClick }) => {
  const disclosureAltText =
    'The Betterment Visa® Debit Card will be issued by nbkc bank; Member FDIC. Debit cards will accompany Checking accounts.';

  return (
    <CenteredWorkflowLayout title="Checking">
      <CenteredWorkflowLayout.Slot name="content">
        <Box
          css={{
            marginBottom: 'space.300',
          }}
        >
          <Box
            css={{
              maxWidth: '60rem',
              margin: '0 auto',

              marginBottom: {
                base: 'space.200',
                sm: 'space.200',
                md: 'space.0',
              },
            }}
          >
            <img src={CheckingSplashImage} alt={disclosureAltText} width="100%" />
          </Box>
        </Box>
        <Heading color="bmtGrey90">Betterment Checking</Heading>
        <Flex justifyContent="center">
          <Box
            css={{
              width: '100%',
            }}
          >
            <SectionLayout pb="6" px="0">
              <Box
                css={{
                  paddingBottom: {
                    base: 'space.400',
                    sm: 'space.400',
                    md: 'space.0',
                  },
                }}
              >
                <Text
                  as="p"
                  css={{
                    marginBottom: 'space.300',
                  }}
                >
                  Our FDIC-insured&Dagger; Checking account takes the hassle out of traditional checking. No credit
                  check required to sign up.
                </Text>
                <Perk
                  icon={<Icon name="Cancel" size="small" color="icon" />}
                  text="No fees&Dagger; or minimum balances."
                />
                <Perk
                  icon={<Icon name="AtmCash" size="small" color="icon" />}
                  text="ATM and foreign transaction fees reimbursed worldwide."
                />
                <Perk
                  icon={<Icon name="People" size="small" color="icon" />}
                  text="Joint accounts for you and your partner to manage your expenses together."
                />
                <Perk
                  icon={<Icon name="ArrowCircle" size="small" color="icon" />}
                  text="Automatic transfers into your Cash Reserve and Investment goals."
                />

                <Button type="button" width={[1, 1 / 3]} onClick={handleClick}>
                  Continue
                </Button>
              </Box>
            </SectionLayout>
          </Box>
        </Flex>
      </CenteredWorkflowLayout.Slot>
      <CenteredWorkflowLayout.Slot name="footer">
        <Footer showCheckingDisclosure={true} />
      </CenteredWorkflowLayout.Slot>
    </CenteredWorkflowLayout>
  );
};

export default Checking;
